import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const options = [
  { value: "All Status", label: "All Status" },
  { value: "In Progress", label: "In Progress" },
  { value: "Completed", label: "Completed" },
//   { value: "Input_sheet_generated", label: "Input Sheet Generated" },
];

export default function CustomDropdown({ filterStatus, setFilterStatus }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (value) => {
    setFilterStatus(value);
    setIsOpen(false);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
      <div
        className="custom-dropdown"
        ref={dropdownRef}
        style={{
          position: "relative",
        display: "inline-block",
          minWidth: "200px",
          fontFamily: "sans-serif",
        }}
      >
        <div
          onClick={toggleDropdown}
          style={{
          border: "1.5px solid #CECECE",
            borderRadius: "4px",
            padding: "8px 30px 8px 12px",
            background: "white",
            cursor: "pointer",
            position: "relative",
          width:"350px"
          }}
        >
        {filterStatus}
          <ChevronDown
            size={16}
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: `translateY(-50%) ${isOpen ? "rotate(180deg)" : ""}`,
              transition: "transform 0.2s ease",
              pointerEvents: "none",
            }}
          />
        </div>

        {isOpen && (
          <ul
            style={{
              listStyle: "none",
              margin: 0,
              padding: 0,
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              background: "white",
              border: "1px solid #ccc",
              borderRadius: "4px",
              maxHeight: "200px",
              overflowY: "auto",
              zIndex: 1000,
            }}
          >
          {options.map((option) => (
              <li
              key={option.value}
              onClick={() => handleSelect(option.value)}
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#c12328") // Red
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "white")
                }
              >
              {option.label}
              </li>
            ))}
          </ul>
        )}
      </div>
  );
}
